// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"ae0abdee","368":"36a731a5"}[chunkId] + ".chunk.js";
};